import { action, thunk, computed } from "easy-peasy";
import authAPI from "../../api/AuthAPI";

const authModel = {
  user: null,
  loggedIn: computed((state) => state.user != null),
  getLoginStatus: thunk(async (actions) => {
    await authAPI.getLoginStatus().then(
      (res) => {
        actions.setUser(res.data.user);
      },
      (err) => {
        actions.setUser(err.data.user);
      }
    );
  }),
  login: thunk(async (actions, payload) => {
    await authAPI.login(payload).then(
      (res) => {
        actions.setUser(res.data.user);
      },
      (err) => {
        actions.setUser(err.data.user);
      }
    );
  }),
  logout: thunk(async (actions) => {
    await authAPI.logout().then(
      (res) => {
        actions.setUser(res.data.user);
      },
      (err) => {
        actions.setUser(err.data.user);
      }
    );
  }),
  //need to handle error in these two. and What to do for success / error (reducers?)
  activate: thunk(async (actions, payload) => {
    await authAPI.activate(payload);
  }),
  signup: thunk(async (actions, payload) => {
    await authAPI.signup(payload);
  }),
  setUser: action((state, payload) => {
    state.user = payload;
  }),
};
export default authModel;
